import { LoadingStyle } from "components/Loading/loading.style";
import dompurify from "dompurify";
import { Form, Formik } from "formik";
import React, { Component } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { AUDIENCIA_MODEL, DADOS_PARAMETRIZADOS_MODEL } from "utils/models";
import ToastHelper from "utils/toastHelper";
import Button from "../../../components/Button/button.component";
import { DivEmail, MunicipiosStyle } from "../../../components/Card/card.style";
import CheckboxGroup from "../../../components/Checkbox/checkboxGroup.component";
import WidgetDialog from "../../../components/Dialog/dialog.component";
import InputText from "../../../components/Input/inputText.component";
import Panel from "../../../components/Panel/panel.component";
import Required from "../../../components/Required/required.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import Title from "../../../components/Title/title.component";
import { MAX_LENGTH_SMS, STATUS_HTTP_OK } from "../../../constants";
import AudienciaService from "../../../services/audienciaService";

class CadastroAudiencia extends Component {
	constructor(props) {
		super(props);
		this.handleEmailChange = this.handleEmailChange.bind(this);

		this.state = {
			isOpenDialog: false,
			isOpenDialogEmail: false,
			isOpenDialogCancelar: false,
			mensagem: "",
			isEmitirAlerta: false,
			isDirty: false,
			audiencia: AUDIENCIA_MODEL,
			dadoParametrizado: DADOS_PARAMETRIZADOS_MODEL,
			key: 0,
			loading: false
		};
	}

	/*
	Funções para calcular os caracteres restantes do sms e do email
	*/
	static getInputLength(values = [], valuesMax) {
		let caracteresRestantes = valuesMax;
		if (values.length !== null || values.length !== undefined) {
			caracteresRestantes = valuesMax - values.length;
		}
		return caracteresRestantes;
	}

	static getContador(values = []) {
		const contTotal = values.length > 0 ? values.length : "";
		return contTotal;
	}

	async componentDidMount() {
		this.initialize();
	}

	componentWillUnmount() {
		const { isEmitirAlerta, audiencia } = this.state;
		if (!isEmitirAlerta) this.handleSubmit(audiencia);
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	initialize = async () => {
		const { alertaId } = this.props;

		/* Resposta dois objetos:
			1ª: emissaoAlerta
			2ª dadosParametrizados
    */
		this.setLoading(true);
		const responseAlerta = await AudienciaService.findAudienciaByAlertaId(
			alertaId
		);
		const { audiencia, dadoParametrizado } = responseAlerta;

		this.setState({
			audiencia: {
				...audiencia
			},
			dadoParametrizado: {
				...dadoParametrizado
			},
			mensagem: audiencia.mensagem,
			key: this.state.key + 1,
			loading: false
		});
	};

	/*
		Emitir alerta, o sweet alert para o caso de haver campos ainda nao preenchidos
		foi movido para o serviço de api
	*/
	emitirAlerta = async () => {
		const { audiencia, mensagem } = this.state;

		const that = this;
		audiencia.mensagem = mensagem;
		this.setLoading(true);
		const response = await AudienciaService.emitirAlerta(audiencia);

		if (response.status === STATUS_HTTP_OK) {
			this.setState({ isEmitirAlerta: true });

			Swal.fire({
				type: "success",
				title: "Alerta emitido com sucesso!",
				showConfirmButton: false,
				timer: 4000
			});

			that.props.history.push("/alertas");
		}
		this.setLoading(false);
	};

	/*
		Modais de cancelar
	*/
	handleDialog = ({ isOpenDialog }) => (
		<WidgetDialog
			isOpen={isOpenDialog}
			confirmar={() => this.setState({ isOpenDialog: false })}
		/>
	);

	handleCancelar = () => {
		this.setState({ isOpenDialogCancelar: true, isDirty: false });
	};

	handleDialogCancelar = ({ isOpenDialogCancelar }) => (
		<WidgetDialog
			title="Atenção!"
			isOpen={isOpenDialogCancelar}
			textCancelar="Não"
			textConfirmar="Sim"
			mensagem="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos"
			cancelar={() => {
				this.setState({ isOpenDialogCancelar: false });
			}}
			confirmar={() => {
				this.setState({ isOpenDialogCancelar: false });
				this.props.history.push("/alertas");
			}}
		/>
	);

	/*
		Modal de visualizar email
	*/
	handleEmail = mensagem => {
		this.setState({ isOpenDialogEmail: true, mensagem });
	};

	handleDialogEmail = ({ isOpenDialogEmail, mensagem }) => (
		<WidgetDialog
			title="Visualização do e-mail"
			isOpen={isOpenDialogEmail}
			textConfirmar="Fechar"
			size="lg"
			mensagem={
				<React.Fragment>
					<span>
						<strong>Assunto:</strong> Emissão de Alerta
					</span>
					<DivEmail>
						<span>
							<strong>ESTADO DO RIO GRANDE DO SUL</strong>
							<br />
							<strong>GOVERNADORIA DO ESTADO</strong>
							<br />
							<strong>CASA MILITAR</strong>
							<br />
							<strong>
								SUBCHEFIA DE PROTEÇÃO E DEFESA CIVIL
							</strong>
							<br />
						</span>
					</DivEmail>
					<br />
					<br />
					{this.innerHTMLPurified(mensagem)}
					<DivEmail>
						<br />
						<br />
						<span>Plantão CODEC</span>
						<br />
						<span>
							<strong>
								{"'"}Defesa Civil somos todos nós.{"'"}
							</strong>
						</span>
						<br />
						<span>
							<u>Defesa Civil</u>
						</span>
						<br />
						<span>
							Rua Gal Andrade Neves, nº 106, 11º Andar - Centro -
							Porto Alegre
						</span>
						<br />
						<span>e-mail: defesa-civil@casamilitar.rs.gov.br</span>
						<br />
						<span>Fone: (51) 3221-7098</span>
						<br />
					</DivEmail>
				</React.Fragment>
			}
			confirmar={() => {
				this.setState({ isOpenDialogEmail: false });
			}}
			fechar={() => {
				this.setState({ isOpenDialogEmail: false });
			}}
		/>
	);

	handleSubmit = async () => {
		const { audiencia, isDirty, mensagem } = this.state;
		if (isDirty) {
			try {
				audiencia.mensagem = mensagem;
				this.setLoading(true);
				await AudienciaService.saveAudiencia(audiencia);
				this.setLoading(false);

				ToastHelper.success("Audiência salva com sucesso!");
			} catch (error) {
				ToastHelper.warn(error.response.data.message);
			}
		}
	};

	/* HANDLE CHANGE INPUTS NORMAIS */
	handleInputChange = event => {
		const { audiencia } = this.state;
		const { target } = event;
		const { name } = target;

		this.setState({
			isDirty: true,
			audiencia: {
				...audiencia,
				[name]: target.value
			}
		});
	};

	/*
		Handler para o campo de email
	*/

	handleEmailChange = (html, delta, source, editor) => {
		const isVazio = editor.getText().trim();
		if (isVazio === "") {
			this.setState({
				isDirty: true,
				mensagem: isVazio
			});
		} else {
			this.setState({
				isDirty: true,
				mensagem: html
			});
		}
	};

	/*
		Handler para o checkbox de midias sociais
	*/
	handleChangeCheckboxGroup(values) {
		const { audiencia } = this.state;
		this.setState({
			isDirty: true,
			audiencia: {
				...audiencia,
				meioComunicacoes: [...values]
			}
		});
	}

	handleHtml = html => {
		const panelSms = html;
		return panelSms;
	};

	innerHTMLPurified = text => {
		const textToBeSanitizer = text;
		const sanitizer = dompurify.sanitize;

		// eslint-disable-next-line react/no-danger
		return (
			<div
				dangerouslySetInnerHTML={{
					__html: sanitizer(textToBeSanitizer) || " "
				}}
			/>
		);
	};

	render() {
		const {
			state: { audiencia, dadoParametrizado },
			props: { onClick }
		} = this;
		return (
			<React.Fragment>
				{this.state.loading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}

				<Title>Audiência</Title>
				<Formik
					initialValues={audiencia}
					enableReinitialize
					onSubmit={this.handleSubmit}
					render={({ setFieldValue, values, errors, touched }) => (
						<Form>
							<div className="row">
								<div className="col-6">
									<Panel
										title="Resumo do alerta"
										styleBody={{
											height: "26em",
											overflow: "auto"
										}}
										body={
											<div className="ml-2">
												<p>
													<b className="font-weight-bold">
														Origem da informação:
													</b>{" "}
													{(
														(
															dadoParametrizado ||
															{}
														).iniciador || {}
													).nome || "-"}
												</p>
												<p>
													<b className="font-weight-bold">
														Data da informação:{" "}
													</b>{" "}
													{dadoParametrizado.dataOcorrencia ||
														"-"}
												</p>
												<p>
													<b className="font-weight-bold">
														Hora da informação:{" "}
													</b>{" "}
													{(
														(
															dadoParametrizado ||
															{}
														).horaOcorrencia || ""
													).substring(5, 0) ||
														" --:-- "}
												</p>
												<p>
													<b className="font-weight-bold">
														Categoria do evento:
													</b>{" "}
													{(
														(
															dadoParametrizado ||
															{}
														).categoria || {}
													).nome || "-"}
												</p>
												<p>
													<b className="font-weight-bold">
														Severidade do evento:
													</b>{" "}
													{(
														(
															dadoParametrizado ||
															{}
														).severidade || {}
													).nome || "-"}
												</p>

												<p>
													<b className="font-weight-bold">
														Período (em horas):
													</b>{" "}
													{dadoParametrizado.periodo ||
														"-"}
												</p>

												<MunicipiosStyle>
													<b className="font-weight-bold">
														Municípios afetados:{" "}
													</b>
													{audiencia.municipios
														.length > 0
														? audiencia.municipios.map(
																(
																	item,
																	index
																) => (
																	<span
																		key={
																			index
																		}
																	>
																		{
																			item.nome
																		}
																		{index ===
																		audiencia
																			.municipios
																			.length -
																			1
																			? ""
																			: ", "}
																	</span>
																)
														  )
														: "-"}
												</MunicipiosStyle>

												<p>
													<b className="font-weight-bold">
														Danos possíveis:{" "}
													</b>{" "}
													{dadoParametrizado.danosPossiveis ||
														"-"}
												</p>
												<p>
													<b className="font-weight-bold">
														Recomendações de
														segurança:{" "}
													</b>{" "}
													{dadoParametrizado.planoContigencia ||
														"-"}
												</p>
												<p>
													<b className="font-weight-bold">
														Informações recebidas da
														origem:{" "}
													</b>{" "}
													{dadoParametrizado.informacoes ||
														"-"}
												</p>
											</div>
										}
									/>
								</div>
								<div className="col-6">
									<Panel
										title={"CREPDEC'S"}
										style={{ height: "13em" }}
										contador={CadastroAudiencia.getContador(
											audiencia.crepdecs
										)}
										id="crepdec"
										body={
											audiencia.crepdecs[0] ? (
												<CheckboxGroup
													isCrepdec
													styleInput={false}
													displayName="nomeExibicao"
													key="crepdecs"
													id="crepdecs"
													name="crepdecs"
													values={
														audiencia.crepdecs || []
													}
													error={errors.crepdecs}
													touched={touched.crepdecs}
													setFieldValue={
														setFieldValue
													}
												/>
											) : (
												<span>
													Não há CREPDEC'S
													selecionadas.
												</span>
											)
										}
									/>
									<Panel
										title="Prefeituras"
										styleBody={{
											height: "12.5em",
											overflow: "auto"
										}}
										contador={CadastroAudiencia.getContador(
											audiencia.municipios
										)}
										id="prefeitura"
										body={
											audiencia.crepdecs[0] ? (
												<CheckboxGroup
													isCrepdec={false}
													styleInput={false}
													key="prefeituras"
													id="municipios"
													name="municipios"
													values={
														audiencia.municipios ||
														[]
													}
													valueid="codigoIbge"
													error={errors.municipios}
													touched={touched.municipios}
													setFieldValue={
														setFieldValue
													}
												/>
											) : (
												<span>
													Não há municípios
													selecionados.
												</span>
											)
										}
									/>
								</div>
							</div>

							<div className="row">
								<div className="col-12 mb-3">
									<Subtitle className="title-mensagem">
										Mensagens: <Required />
									</Subtitle>
								</div>
								<div className="col-md-6">
									<Panel
										title="SMS"
										titleName="O SMS deverá ser inserido no IDAP"
										id="Sms"
										subTitle="Digite a mensagem enviada pelo sistema do IDAP:"
										qtdCaracteres={CadastroAudiencia.getInputLength(
											values.sms,
											MAX_LENGTH_SMS
										)}
										style={{ height: "100%" }}
										body={
											<InputText
												className="container-fluid"
												type="textarea"
												name="sms"
												value={values.sms}
												onChange={
													this.handleInputChange
												}
												maxLength="150"
												style={{ height: "10em" }}
											/>
										}
										idap={
											<p className="ml-2 mt-5">
												<a
													target="_blank"
													rel="noopener noreferrer"
													href="http://idap-tv.mi.gov.br/#/auth/login"
												>
													Clique aqui para acessar o
													site do IDAP
												</a>
											</p>
										}
									/>
								</div>
								<div key={this.state.key} className="col-6">
									<Panel
										title="E-mail"
										subTitle="Digite o e-mail a ser enviado:"
										style={{ height: "100%" }}
										body={
											<ReactQuill
												onChange={
													this.handleEmailChange
												}
												defaultValue={
													this.state.mensagem ||
													values.mensagem
												}
												style={{
													overflowY: "scroll",
													maxHeight: "18.2em"
												}}
											/>
										}
										idap={
											<div>
												<Button
													onClick={() =>
														this.handleEmail(
															this.state.mensagem
														)
													}
													type="button"
													className="mt-3"
													info="true"
													primary
													text="Visualizar e-mail"
												/>
											</div>
										}
									/>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-6">
									<div className="row">
										<div className="col-md-12">
											<div className="float-left ">
												<Button
													onClick={() =>
														onClick("analise")
													}
													type="submit"
													primary
													text="Voltar"
													icon="fas fa-arrow-left"
												/>
												<Button
													onClick={() =>
														this.handleCancelar()
													}
													cancel
													type="button"
													text="Cancelar"
													icon="fas fa-times"
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="col-6">
									<div className="row">
										<div className="col-md-12">
											<div className="float-right">
												<Button
													primary
													text="Salvar"
													icon="fas fa-save"
													type="submit"
												/>
												<Button
													primary
													text="Emitir alerta"
													icon="fas fa-paper-plane"
													type="button"
													onClick={this.emitirAlerta}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Form>
					)}
				/>
				{this.handleDialog(this.state)}
				{this.handleDialogEmail(this.state)}
				{this.handleDialogCancelar(this.state)}
			</React.Fragment>
		);
	}
}

export default withRouter(CadastroAudiencia);
